import { render, staticRenderFns } from "./WithdrawCandidateAction.vue?vue&type=template&id=48c4de3a&"
import script from "./WithdrawCandidateAction.vue?vue&type=script&lang=js&"
export * from "./WithdrawCandidateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports